module.exports = __webpack_public_path__ + "img/dino-send.cc126b92.jpeg";